import { render, staticRenderFns } from "./BillingDocumentsManagement.vue?vue&type=template&id=47d529c2"
import script from "./BillingDocumentsManagement.vue?vue&type=script&lang=js"
export * from "./BillingDocumentsManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports